import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  type: 'object',
  properties: {
    ids: {
      type: 'array',
      title: '',
      items: {
        type: 'number'
      },
      calc: 'this.entities.map( item => item.id)'
    },
    id: {
      type: 'number',
      title: 'identyfikator',
      fieldRequired: true
    },
    entities: {
      computed: true,
      type: 'array',
      items: {
        type: 'object',
        properties: {
          name: {
            type: 'string'
          },
          id: {
            type: 'number'
          }
        }
      }
    }
  }
};
